import React from 'react';
import moment from 'moment';
import { DatePickerInput } from 'rc-datepicker';
import { Field, ButtonRadio, Select } from '../Common';
import { connect } from 'react-redux';


class DigitalChargedForm extends React.Component {
    constructor(props) {
        super(props);
		
		const parseDateFromInstant = (dateNaissance) => {
            if (!dateNaissance) return null;
            
            if (moment.isMoment(dateNaissance)) {
                return dateNaissance;
            }
            
            if (dateNaissance.epochSecond) {
                return moment.unix(dateNaissance.epochSecond).startOf('day');
            }
            
            if (typeof dateNaissance === 'string' && moment(dateNaissance).isValid()) {
                return moment(dateNaissance).startOf('day');
            }
            
            return null;
        };
		
		const dateNaissance = this.props.serverDigitalChargedData && this.props.serverDigitalChargedData.dateNaissance;
		const date = parseDateFromInstant(dateNaissance);
		
        this.state = {
            readonly: false,
            date: date,
            startDate: moment(),
            calendarFocused: false,
            firstName: this.props.serverDigitalChargedData && this.props.serverDigitalChargedData.prenom ? this.props.serverDigitalChargedData.prenom : '',
            name: this.props.serverDigitalChargedData && this.props.serverDigitalChargedData.nom ? this.props.serverDigitalChargedData.nom : '',
            email: this.props.serverDigitalChargedData && this.props.serverDigitalChargedData.email ? this.props.serverDigitalChargedData.email : '',
            telephone: this.props.serverDigitalChargedData && this.props.serverDigitalChargedData.telephone ? this.props.serverDigitalChargedData.telephone : '',
            address: this.props.serverDigitalChargedData && this.props.serverDigitalChargedData.address ? this.props.serverDigitalChargedData.address : '',
            zipCode: this.props.serverDigitalChargedData && this.props.serverDigitalChargedData.zipCode ? this.props.serverDigitalChargedData.zipCode : '',
            city: this.props.serverDigitalChargedData && this.props.serverDigitalChargedData.city ? this.props.serverDigitalChargedData.city : '',
            profils: this.props.serverDigitalChargedData && this.props.serverDigitalChargedData.profils.length > 0 ? this.props.serverDigitalChargedData.profils : [''],
            codeCountry: this.props.serverDigitalChargedData && this.props.serverDigitalChargedData.codeCountry ? this.props.serverDigitalChargedData.codeCountry : "79",
            addDigitalCharged: this.props.serverDigitalChargedData && this.props.serverDigitalChargedData.nom ? '1' : '0',
            mission: this.props.serverDigitalChargedData && this.props.serverDigitalChargedData.mission ? this.props.serverDigitalChargedData.mission: '',
            digitalCharged: this.props.serverDigitalChargedData && this.props.serverDigitalChargedData.mission ? this.props.serverDigitalChargedData.mission: '',
            facebook: '',
            twitter: '',
            error: {
                name: '',
                address: '',
                email: '',
                telephone: '',
                zipCode: '',
                city: '',
                codeCountry: '',
                date: '',
                profils: '',
                digitalCharged: '',
            }
        }
        this.handleChange = this.handleChange.bind(this)
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

	dateOnChange = (jsDate, dateString) => {
		
		let momentDate = null;
		
		if (jsDate instanceof Date && !isNaN(jsDate)) {
			momentDate = moment(jsDate).startOf('day');
		} else if (moment.isMoment(jsDate) && jsDate.isValid()) {
			momentDate = jsDate.startOf('day');
		}
		
		let obj = {}
		obj.date = (!momentDate || !momentDate.isValid()) ? 'is-invalid' : ''
		
		this.setState(prevState => ({
			date: momentDate, 
			error: {
				...prevState.error,
				...obj
			}
		}));
	}

    addProfil = () => {
        this.setState(prevState => ({
            profils: [...prevState.profils, '']
        }));
    }

    removeItem = (index) => {
        let profils = [...this.state.profils]
        profils.splice(index, 1);
        this.setState(() => ({ profils }));
    }

    onProfilChange = (key, e) => {
        const value = e.target.value;
        const { profils } = this.state;

        profils[key] = value;

        // update state
        this.setState({
            profils,
        });
    };

    handleChange(value) {
        this.setState({ date: value })
    }
    onZipCodeChange(key, e) {
        const value = e.target.value;
        if (!isNaN(value)) {
            this.setState(() => ({ [key]: value }));
        }
    }
    handleOnChange(key, e) {
        const value = e.target.value;
        this.setState(() => ({ [key]: value }));
    }


    handleOnChangeMemoryCharged(key, e) {
        const value = e.target.value;
        if (key == 'digitalCharged') {
            this.setState(prevState => ({
                ...prevState,
                ... this.props.memoryChargedData,
                firstName: this.props.memoryChargedData.prenom,
                name: this.props.memoryChargedData.nom,
                date: this.props.memoryChargedData.dateNaissance,
                digitalCharged: value,
                readonly: true,
                mission: value
            }))
        }
        else if (key == 'digitalChargedSuppleant') {
            this.setState(prevState => ({
                ...prevState,
                ... this.props.alternateMemoryChargedData,
                firstName: this.props.alternateMemoryChargedData.prenom,
                name: this.props.alternateMemoryChargedData.nom,
                date: this.props.alternateMemoryChargedData.dateNaissance,
                digitalCharged: value,
                readonly: true,
                mission: value
            }))

        }

        else if (key == 'thirdPerson') {
            this.setState(prevState => ({
                ...prevState,
                ... this.props.serverDigitalChargedData,
                firstName: this.props.serverDigitalChargedData && this.props.serverDigitalChargedData.prenom ? this.props.serverDigitalChargedData.prenom : '',
                name: this.props.serverDigitalChargedData && this.props.serverDigitalChargedData.nom ? this.props.serverDigitalChargedData.nom : '',
                email: this.props.serverDigitalChargedData && this.props.serverDigitalChargedData.email ? this.props.serverDigitalChargedData.email : '',
                date: this.props.serverDigitalChargedData && this.props.serverDigitalChargedData.dateNaissance ? this.props.serverDigitalChargedData.dateNaissance : '',
        		telephone: this.props.serverDigitalChargedData && this.props.serverDigitalChargedData.telephone ? this.props.serverDigitalChargedData.telephone : '',
	            address: this.props.serverDigitalChargedData && this.props.serverDigitalChargedData.address ? this.props.serverDigitalChargedData.address : '',
	            zipCode: this.props.serverDigitalChargedData && this.props.serverDigitalChargedData.zipCode ? this.props.serverDigitalChargedData.zipCode : '',
                city: this.props.serverDigitalChargedData && this.props.serverDigitalChargedData.city ? this.props.serverDigitalChargedData.city : '',
                codeCountry: this.props.serverDigitalChargedData && this.props.serverDigitalChargedData.codeCountry ? this.props.serverDigitalChargedData.codeCountry : "79",
                profils: this.props.serverDigitalChargedData && this.props.serverDigitalChargedData.profils.length > 0 ? this.props.serverDigitalChargedData.profils : [''],
	            digitalCharged: value,
                readonly: false,
                addDigitalCharged: '1',
                mission: value

            }))
        }
    }


    onSubmit = (e) => {
        e.preventDefault();
        const name = (!this.state.name) ? ' is-invalid' : '';
        const firstName = (!this.state.firstName) ? ' is-invalid' : '';
        const date = (!this.state.date || !moment.isMoment(this.state.date) || !this.state.date.isValid()) ? ' is-invalid' : '';
		const dateToSend = this.state.date ? this.state.date.format('YYYY-MM-DD') : null;
        const address = (!this.state.address) ? ' is-invalid' : '';
        const zipCode = (!this.state.zipCode) ? ' is-invalid' : '';
        const city = (!this.state.city) ? ' is-invalid' : '';
        const codeCountry = (!this.state.codeCountry) ? ' is-invalid' : '';
        const email = (!this.state.email) ? ' is-invalid' : '';
        const telephone = (!this.state.telephone) ? ' is-invalid' : '';
        const profils = (!this.state.profils) ? ' is-invalid' : '';
        let digitalCharged = '';
        if (this.state.addDigitalCharged === '1') {
            digitalCharged = (!this.state.digitalCharged) ? ' is-invalid' : '';
        }
        this.setState(prevState => ({
            error: {
                ...prevState.error,
                name,
                firstName,
                date,
                email,
                telephone,
                address,
                zipCode,
                city,
                codeCountry,
                profils,
                digitalCharged
            }
        }))
        if (this.state.addDigitalCharged === '0')
            this.props.onDigitalChargedSubmit({
                firstName: '',
                name: '',
                date: '',
                address: '',
                zipCode: '',
                city: '',
                digitalCharged: '',
                facebook: '',
                twitter: '',
                codeCountry: '',
                email: '',
                telephone: '',
                profils: '',
                addDigitalCharged: '0'
            });
        else if (!name && !firstName && !date && !address && !zipCode && !city && !codeCountry && !telephone && !email && !profils && !digitalCharged)
            this.props.onDigitalChargedSubmit({
                firstName: this.state.firstName,
                name: this.state.name,
                date: dateToSend, 
                address: this.state.address,
                zipCode: this.state.zipCode,
                city: this.state.city,
                digitalCharged: this.state.digitalCharged,
                facebook: this.state.facebook,
                twitter: this.state.twitter,
                codeCountry: this.state.codeCountry,
                email: this.state.email,
                telephone: this.state.telephone,
                profils: this.state.profils,
                addDigitalCharged: this.state.addDigitalCharged,
                mission: this.state.mission
            });
    }

    render() {
        return (
            <form onSubmit={this.onSubmit} className="_digital">
                <p>
                    Le chargé numérique a quant à lui pour mission de demander la clôture de vos profils sur les réseaux sociaux.
                   <br />
                    Souhaitez-vous désigner un chargé numérique ?
                </p>
                <div className="alternate-radio-buttons">
                    <ButtonRadio
                        type="radio"
                        _id="adc1"
                        name="addDigitalCharged"
                        value="1"
                        checked={this.state.addDigitalCharged == "1"}
                        onChange={this.handleOnChange.bind(this, "addDigitalCharged")}
                        label="Oui"

                    />
                    <ButtonRadio
                        type="radio"
                        _id="adc2"
                        name="addDigitalCharged"
                        value="0"
                        checked={this.state.addDigitalCharged == "0"}
                        onChange={this.handleOnChange.bind(this, "addDigitalCharged")}
                        label="Non"
                    />
                </div>

                {this.state.addDigitalCharged == "1" &&
                    <h4>Pour clôturer mes comptes sur les réseaux sociaux, je désigne comme Chargé numérique </h4>
                }

                {this.state.addDigitalCharged == "1" &&
                    <div className="form-container">
                        <ButtonRadio
                            type="radio"
                            _id="checkboxDc1"
                            name="digitalCharged"
                            value="chargeMemoire"
                            label="Mon chargé de mémoire"
                            _className={this.state.error.digitalCharged}
                            checked={this.state.mission == "chargeMemoire"}
                            onChange={this.handleOnChangeMemoryCharged.bind(this, 'digitalCharged')}
                        />
                        {this.props.alternateMemoryChargedData.nom &&
                            <ButtonRadio
                                type="radio"
                                _id="checkboxDc2"
                                name="digitalCharged"
                                value="chargeSupp"
                                label="Mon chargé de mémoire suppléant"
                                _className={this.state.error.digitalCharged}
                                checked={this.state.mission == "chargeSupp"}
                                onChange={this.handleOnChangeMemoryCharged.bind(this, 'digitalChargedSuppleant')}
                            />
                        }
                        <ButtonRadio
                            type="radio"
                            _id="checkboxDc3"
                            name="digitalCharged"
                            value="autre"
                            label="Une tierce personne"
                            _className={this.state.error.digitalCharged}
                            checked={this.state.mission == "autre"}
                            onChange={this.handleOnChangeMemoryCharged.bind(this, 'thirdPerson')}
                        />
                        {this.state.error.digitalCharged &&
                            <div className="invalid-feedback invalid-date">
                                Le champ Chargé numérique * est obligatoire 
                            </div>
                        }
                    </div>
                }

                <div className="separator-container"></div>

                {this.state.addDigitalCharged == "1" &&

                    <div className="row cn-container">
                        <div className="col-sm-5">
                            <img src='/images/b3-page-lg.png' alt="image profil" className="_lg" />
                            <img src='/images/nc-sm-page.png' alt="image profil" className="_sm" />
                        </div>
                        <div className="col-sm-7 form-container top-form">
                            <Field
                                label="Nom *"
                                type="text"
                                // placeholder="DUPOND"
                                _className={"form-control  " + this.state.error.name}
                                value={this.state.name}
                                onChange={this.handleOnChange.bind(this, "name")}
                                error={this.state.error.name}
                                readOnly={this.state.readonly}
                            />
                            <Field
                                label="Prénom *"
                                type="text"
                                // placeholder="ALAIN"
                                _className={"form-control  " + this.state.error.firstName}
                                value={this.state.firstName}
                                onChange={this.handleOnChange.bind(this, "firstName")}
                                error={this.state.error.firstName}
                                readOnly={this.state.readonly}
                            />
                            <div className="form-group">
                                <label>Date de naissance *</label>
                                <DatePickerInput
                                    onChange={this.dateOnChange}
                                    value={this.state.date}
                                    maxDate={moment()}
                                    className={this.state.readonly ? 'custom-datepicker readonly ' + this.state.error.date : 'custom-datepicker ' + this.state.error.date}
                                    showOnInputClick={true}
                                    iconClassName='cal-icon'
                                    locale = 'fr'
                                />
                                {this.state.error.date &&
                                    <div className="invalid-feedback invalid-date">
                                        Le champ Date de naissance *  est obligatoire
	                                </div>
                                }
                            </div>
                            <Field
                                label="Email *"
                                type="email"
                                _className={"form-control  " + this.state.error.email}
                                value={this.state.email}
                                onChange={this.handleOnChange.bind(this, "email")}
                                error={this.state.error.email}
                                readOnly={this.state.readonly}
                            />
                            <Field
                                label="Numéro de téléphone*"
                                type="text"
                                _className={"form-control  " + this.state.error.telephone}
                                value={this.state.telephone}
                                onChange={this.handleOnChange.bind(this, "telephone")}
                                error={this.state.error.telephone}
                                readOnly={this.state.readonly}
                            />
                            <Field
                                label="Adresse *"
                                type="text"
                                _className={"form-control  address" + this.state.error.address}
                                value={this.state.address}
                                onChange={this.handleOnChange.bind(this, "address")}
                                error={this.state.error.address}
                                readOnly={this.state.readonly}
                            //placeholder="1 rue de Charles de Gaule"
                            />
                            <Field
                                label="Code postal *"
                                type="text"
                                _className={"form-control  " + this.state.error.zipCode}
                                value={this.state.zipCode}
                                onChange={this.onZipCodeChange.bind(this, "zipCode")}
                                error={this.state.error.zipCode}
                                readOnly={this.state.readonly}
                            // placeholder="97860"
                            />
                            <Field
                                label="Ville *"
                                type="text"
                                _className={"form-control  " + this.state.error.city}
                                value={this.state.city}
                                onChange={this.handleOnChange.bind(this, "city")}
                                error={this.state.error.city}
                                readOnly={this.state.readonly}
                            //  placeholder="MARNY SUR OISE"
                            />
                            <Select
                                label="Pays *"
                                error={this.state.error.codeCountry}
                                _className={"form-control address " + this.state.error.codeCountry}
                                value={this.state.codeCountry}
                                onChange={this.handleOnChange.bind(this, 'codeCountry')}
                                list={this.props.countryData.list}
                                selectType="obj"
                                optionValue="id"
                                optionLabel="libelle"
                                readOnly={this.state.readonly}
                            />
                            <h5>Vous devrez informer cette personne de sa mission</h5>
                            <div className="required-txt"> * Champs obligatoires</div>
                        </div>
                    </div>
                }
                {this.state.addDigitalCharged == "1" &&
                	<div className="col-sm-12 form-container">
		                <div className="form-group">
		                	<label>Adresses comptes sociaux à clotûrer :</label>
		                    {this.state.addDigitalCharged == "1" && this.state.profils && this.state.profils.map((reseauSocial, i) =>
		                        <div className="row" key={i}>
		                            <div className="first-reseauSocial col-sm-12">
		                                {i > 0 &&
		                                    <div className='btn-remove' onClick={() => this.removeItem(i)}>X</div>
		                                }
		                                <Field
		                                    type="text"
		
		                                    _className={"form-control social " + this.state.error.name}
		                                    onChange={this.onProfilChange.bind(this, i)}
		                                    // onChange={this.onProfilChange.bind(this, "social")}
		                                    value={reseauSocial}
		                                    error={this.state.error.name}
		                                />
		                            </div>
		                        </div>
		                    )}
		                    <div className="btn-add" onClick={this.addProfil} />
		                </div>
		            </div>
                }
                
                <div className="col-sm-12  button-container ">
                    <button type="button" onClick={this.props.back} className="btn btn-outline-primary " >{'< Precedent'}</button>
                    <button type="submit" className="btn btn-primary ">Enregistrer</button>
                </div>
            </form>
        )
    }
}

const mapStateToProps = state => {
    return {
        alternateMemoryChargedData: state.alternateMemroyChargedData,
        countryData: state.countryData
    }
}

export default connect(mapStateToProps)(DigitalChargedForm);


// WEBPACK FOOTER //
// ./src/components/MemoryChargedPage/DigitalChargedForm.js